/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleLoginRequest
 */
export interface GoogleLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof GoogleLoginRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLoginRequest
     */
    role: string;
}

/**
 * Check if a given object implements the GoogleLoginRequest interface.
 */
export function instanceOfGoogleLoginRequest(value: object): value is GoogleLoginRequest {
    if (!('returnUrl' in value) || value['returnUrl'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function GoogleLoginRequestFromJSON(json: any): GoogleLoginRequest {
    return GoogleLoginRequestFromJSONTyped(json, false);
}

export function GoogleLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'returnUrl': json['returnUrl'],
        'role': json['role'],
    };
}

export function GoogleLoginRequestToJSON(json: any): GoogleLoginRequest {
    return GoogleLoginRequestToJSONTyped(json, false);
}

export function GoogleLoginRequestToJSONTyped(value?: GoogleLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returnUrl': value['returnUrl'],
        'role': value['role'],
    };
}

